import WorkUsers from '@atom/components/common/workUsers/WorkUsers';
import {
  AssetRequestUser,
  AssetRequestUserGroup,
} from '@atom/types/assetRequest';
import { UserDetail } from '@atom/types/user';

type RequestAssigneesProps = {
  users?: AssetRequestUser[];
  userGroups?: AssetRequestUserGroup[];
};

const RequestAssignees = ({
  users = [],
  userGroups = [],
}: RequestAssigneesProps) => (
  <WorkUsers users={users as UserDetail[]} userGroups={userGroups} />
);

export default RequestAssignees;
